export default "{{ displayValue }}\r\n";